"use client"

import type { ReactNode } from "react"
import { Card, CardContent } from "@/components/ui/card"

interface ProfileStatCardProps {
  icon: ReactNode
  label: string
  value: string | number
  color: "purple" | "teal" | "orange"
}

const colorClasses = {
  purple: "bg-purple-100",
  teal: "bg-teal-100",
  orange: "bg-orange-100",
}

const valueColorClasses = {
  purple: "text-purple-600",
  teal: "text-teal-600",
  orange: "text-orange-600",
}

export function ProfileStatCard({ icon, label, value, color }: ProfileStatCardProps) {
  return (
    <Card className="border-slate-200 hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1">
      <CardContent className="p-6 flex items-center gap-6">
        <div className={`p-4 ${colorClasses[color]} rounded-lg flex items-center justify-center`}>{icon}</div>
        <div>
          <p className="text-sm text-slate-600 font-medium">{label}</p>
          <p className={`text-3xl font-bold ${valueColorClasses[color]}`}>{value}</p>
        </div>
      </CardContent>
    </Card>
  )
}
